import { slices } from "@/constants/sliceNames";
import { createSlice } from "@reduxjs/toolkit";
import { requestUserPermissionsStatus } from "../effects/authorization-effects";

const initialState = {
  permissions: [],
  loading: false,
};

const authorizationSlice = createSlice({
  name: slices.authorization,
  initialState,
  extraReducers: {
    ...requestUserPermissionsStatus,
  },
});

const { actions, reducer } = authorizationSlice;

export { actions };

export default reducer;
